<template>
  <div class="payload-field-row field is-grouped">
    <p class="control" style="width: 20%">
      <input
        v-model="localField.key"
        class="input is-small"
        type="text"
        :placeholder="$t('key')"
        @input="emitChange"
      >
    </p>
    <p class="control" style="width: 15%">
      <span class="select is-small is-fullwidth">
        <select v-model="localField.value_type" @change="emitChange">
          <option value="mapping">{{ $t('apiChannel.mapping') }}</option>
          <option value="constant">{{ $t('apiChannel.constant') }}</option>
        </select>
      </span>
    </p>
    <p class="control is-expanded">
      <template v-if="localField.value_type === 'mapping'">
        <span class="select is-small is-fullwidth">
          <select v-model="localField.source_field" @change="emitChange">
            <option disabled value="">{{ $t('apiChannel.selectField') }}</option>
            <option v-for="field in indexFields" :key="field" :value="field">
              {{ field }}
            </option>
          </select>
        </span>
      </template>
      <template v-else>
        <div class="field has-addons">
          <p class="control">
            <span class="select is-small">
              <select v-model="localField.constant_type" @change="emitChange">
                <option value="string">String</option>
                <option value="number">Number</option>
                <option value="boolean">Boolean</option>
                <option value="null">Null</option>
              </select>
            </span>
          </p>
          <p class="control is-expanded">
            <template v-if="localField.constant_type === 'boolean'">
              <span class="select is-small is-fullwidth">
                <select v-model="localField.constant_value" @change="emitChange">
                  <option :value="true">true</option>
                  <option :value="false">false</option>
                </select>
              </span>
            </template>
            <template v-else-if="localField.constant_type === 'null'">
              <input class="input is-small" type="text" value="null" disabled>
            </template>
            <template v-else-if="localField.constant_type === 'number'">
              <input
                v-model.number="localField.constant_value"
                class="input is-small"
                type="number"
                :placeholder="$t('value')"
                @input="emitChange"
              >
            </template>
            <template v-else>
              <input
                v-model="localField.constant_value"
                class="input is-small"
                type="text"
                :placeholder="$t('value')"
                @input="emitChange"
              >
            </template>
          </p>
        </div>
      </template>
    </p>
    <p class="control">
      <button type="button" class="button is-danger is-small" @click="$emit('remove')">
        <octicon :icon="x" />
      </button>
    </p>
  </div>
</template>

<script>
import { x } from 'octicons-vue'

export default {
  name: 'PayloadFieldRow',
  props: {
    field: {
      type: Object,
      required: true
    },
    indexFields: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      localField: { ...this.field }
    }
  },
  computed: {
    x () {
      return x
    }
  },
  watch: {
    field: {
      handler (newVal) {
        this.localField = { ...newVal }
      },
      deep: true
    }
  },
  methods: {
    emitChange () {
      if (this.localField.constant_type === 'null') {
        this.localField.constant_value = null
      }
      this.$emit('update', { ...this.localField })
    }
  }
}
</script>

<style scoped>
.payload-field-row {
  margin-bottom: 0.5rem;
}
</style>
